export default __webpack_public_path__ + "static/media/player_transfer.9653c55d.gif";